var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headline_text"},[_c('h1',{staticClass:"entry-title"},[_vm._v(_vm._s(_vm.headline))])])
}
var staticRenderFns = []

export { render, staticRenderFns }